import { TENANT_TYPES } from './tenant-types';

// User Self-Registration Code (Static)
export const TENANT_TYPE_TO_REG_CODE = {
  [TENANT_TYPES.CYBERINT_CUSTOMER]: 'INERM',
  [TENANT_TYPES.CYBERINT_MANAGEMENT]: 'INERM',
  [TENANT_TYPES.CYBERINT_PROVISIONING]: 'ERMTEMP',
  [TENANT_TYPES.MSSP_MANAGEMENT]: 'ERMMSSP'
  // [TENANT_TYPES.MSSP_PROVISIONING]: 'ERMTEMP',
  // [TENANT_TYPES.MSSP_PARENT_ALLOCATED]: 'INERMMSPC',
  // [TENANT_TYPES.MSSP_STANDALONE_ALLOCATED]: 'INERMMSPC'
};

// Supported Tenant Types for Each Workflow
export const LITMOS_ADMIN_SUPPORTED_TENANTS = [
  TENANT_TYPES.CYBERINT_CUSTOMER,
  TENANT_TYPES.MSSP_MANAGEMENT,
  TENANT_TYPES.CYBERINT_PROVISIONING
  // TENANT_TYPES.MSSP_PROVISIONING,
  // TENANT_TYPES.MSSP_PARENT_ALLOCATION,
  // TENANT_TYPES.MSSP_STANDALONE_ALLOCATION
];

export const LITMOS_USER_SUPPORTED_TENANTS = [
  TENANT_TYPES.MSSP_MANAGEMENT,
  TENANT_TYPES.CYBERINT_PROVISIONING,
  TENANT_TYPES.CYBERINT_CUSTOMER
];

// Litmos Self-Registration URL
export const LITMOS_SELF_REGISTRATION_URL = 'https://checkpointpublic.litmoseu.com/self-signup';
